/* Our PSPs act much like menus, but have additional variables for
 * remaining partially on screen when "closed" and
 * for disappearing on scroll
 */

import { Menu } from "./menu.js";

export class Psp extends Menu {
    constructor(toggler, container, openClass, speed, openHeight, closedHeight, visible) {
        super(options);
        this.openHeight = openHeight;
        this.closedHeight = closedHeight;
        this.visible = visible;
    };
}


// WEBPACK FOOTER //
// ./Scripts/src/psp.js